<script>
import { fandomBasicMixin } from "src/modules/fandom_mixins_module.js";
import { interactionMixin, getUrlFromPath } from "src/modules/interactions_module.js";
import { KenwoodItaly } from '../../modules/kenwood_italy_module.js';
import { get } from "lodash";

export default {
  mixins: [fandomBasicMixin, interactionMixin],
  data: function () {
    return {
      sharePath: "",
      shareUrl: "",
      linkedContent: null,
    };
  },
  mounted: function() {
    if(this.isUserRegistered()) {
      Fandom.ajax({
        method: "POST",
        url: "/api/v5/get_ugc_video_contest_content",
        data: { },
        success: (data) => {
          if (data.success && data.content) {
            this.sharePath =  data.content.slug;
            Vue.set(this, "linkedContent", data.content);
          }
        },
        error: (xhr, ajaxOptions, thrownError) => {}
      });
    }
  },
  methods: {
    isUserRegistered: Fandom.isUserRegistered,
    startLinkShare() {
      this.copyToClipboard();
      this.updateShareInteraction(this.linkedContent, this.linkedContent, this.linkedShareInteraction.interaction, "link", this.sharePath, false);
    },
    copyToClipboard() {
      const textarea = this.$refs["textarea"];
      const selection = window.getSelection();
      const range = document.createRange();
      const editable = textarea.contentEditable;
      const readOnly = textarea.readOnly;

      textarea.contentEditable = true;
      textarea.readOnly = false;

      this.shareUrl = getUrlFromPath(this.sharePath, this.isIframe, this.content.name);
      range.selectNodeContents(textarea);
      selection.removeAllRanges();
      selection.addRange(range);

      textarea.setSelectionRange(0, 999999);
      textarea.contentEditable = editable;
      textarea.readOnly = readOnly;

      const copyStatus = document.execCommand("copy");
      console.log(copyStatus);
      if (copyStatus) {
        $(this.$refs["modal"]).appendTo("body").modal("show");
      }

      selection.removeAllRanges();
    }
  },
  computed: {
    owner() {
      return (Fandom.exists(this.content.owned_by) && this.pageModel.id_to_user[this.content.owned_by]) ? this.pageModel.id_to_user[this.content.owned_by] : null;
    },
    linkedShareInteraction() {
      return (this.linkedContent.interactions && this.linkedContent.interactions["share"]) ? this.linkedContent.interactions["share"] : false;
    },
  }
};
</script>

<template>
  <div v-easyadmin="easyadminId" :class="contentType" class="position-relative" >
    <div v-if="isUserRegistered() && linkedContent" class="bg-cheddar w-100">
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-12 col-lg-10 col-xl-8 d-flex py-2">
            <div class="flex-grow-1 d-flex align-items-center">{{ft("linked_ugc.share_message")}}</div>
            <div class="share-button">
              <button role="button "class="btn btn-outline-black wm-50 mr-1 px-3" @click="startLinkShare()" >{{ft("vote.share")}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- share link modal -->
    <div class="modal fade" ref="modal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header position-relative border-0">
            <h5 class="h4 w-100 d-inline-block text-center">{{ft("globals.share_with_friends")}}</h5>
            <button type="button" class="close m-0 p-0" data-dismiss="modal" aria-label="Close">
              <i aria-hidden="true" class="fal fa-times text-black"></i>
            </button>
          </div>
          <div class="modal-body">
            <div class="input-group">
              <textarea class="w-100 form-control" ref="textarea" v-model="shareUrl"></textarea>
            </div>
            <div class="py-3 text-center text-kenwood-dark-grey">
              (link copiato negli appunti)
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
  </div>
</template>

<style lang="scss">



</style>